import { StatusCodes } from 'http-status-codes';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import SettingsApi from '~/src/services/api/SettingsApi';
import TextInputComponent from '~/src/components/common/forms/TextInput/TextInputComponent';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import FormRow from '~/src/components/common/forms/Row/FormRow';
import { useHistory } from 'react-router-dom';

const schema = yup.object().shape({
  daysBeforeExpiration: yup.number().integer().required(),
  EmailWhenReservationProblemOccurs: yup.string().required(),
});

interface Setting {
  key: 'daysBeforeExpiration' | 'EmailWhenReservationProblemOccurs';
  value: string | number;
  comment: string;
  valueType: string;
}

export default function SettingsPage(): JSX.Element {
  const [settings, setSettings] = useState<Setting[]>([]);
  const [settingGroups, setSettingGroups] = useState<string[]>([]);
  const history = useHistory();
  
  const getSettings = async () => {
    const res = await SettingsApi.get();

    if (res.status === StatusCodes.OK) {
      res.data.forEach((element) => {
        formik.setFieldValue(element.key, element.value);
      });
      setSettings(res.data);
      const groups = res.data.map((item) => item.group);
      const uniqueGr = groups.filter((v, i, a) => a.indexOf(v) === i);
      setSettingGroups(uniqueGr);
    }
  };

  const updateSettings = (values, setSubmitting) => {
    // TODO: manual validations of types
    console.log('updating');
  };

  const formik = useFormik({
    initialValues: {
      EmailWhenReservationProblemOccurs: '',
      daysBeforeExpiration: '',
    },
    validationSchema: schema,
    onSubmit: (values, { setSubmitting }) => {
      return updateSettings(values, setSubmitting);
    },
  });

  const updateSingleSetting = async (key) => {
    const ourSetting = settings.find((i) => i.key == key);
    if (ourSetting) {
      ourSetting.value = formik.values[key];
      const res = await SettingsApi.update(ourSetting.id, ourSetting);
    } else {
      console.log('no such setting');
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  return (
    <WhitePad>
      <TitleComponent title="Settings" 
       titleLeft="Back"
       onLeftHandler={(): void => history.goBack()}
       />

      {settingGroups?.map((group) => {
        const forGroup = settings.filter((s) => s.group == group);

        return (
          <div key={group}>
            <TitleComponent title={group} />
            {forGroup?.map((setting) => {

              return (
                <FormRow>
                  <TextInputComponent
                    key={setting.key}
                    name={setting.key}
                    value={formik.values[setting.key]}
                    onChange={formik.handleChange}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      updateSingleSetting(setting.key);
                    }}
                    errors={formik.errors}
                    touched={formik.touched}
                    label={`${setting.key}: ${setting.comment}`}
                  />
                </FormRow>
              );
            })}
          </div>
        );
      })}
    </WhitePad>
  );
}
